(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionTypeRankingController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        /**
         * @property {{
         *      ODDQuestionChoices: [ODDQuestionChoice]
         *      ODDQuestionLabels: [ODDQuestionLabel]
         * }} boxModel
         * @property {{
         *      ODDQuestionChoiceID
         *      TitleEN
         * }} ODDQuestionChoice
         * @property {{
         *      ODDQuestionLabelID
         *      TitleEN
         * }} ODDQuestionLabel
         */

        $scope.ctxtCtrl.newChoice = {};

        $scope.createOrUpdateRanking = function () {
            $scope.createOrUpdate();
        };

        $scope.labelListUpdated = function () {
            if (!$scope.boxModel.ODDQuestionChoices) $scope.boxModel.ODDQuestionChoices = [];
            _.each($scope.boxModel.ODDQuestionLabels, function (label, index) {
                if (_.isUndefined($scope.boxModel.ODDQuestionChoices[index])) {
                    $scope.boxModel.ODDQuestionChoices.push({
                        TitleEN: index + 1
                    })
                } else {
                    $scope.boxModel.ODDQuestionChoices[index].TitleEN = index + 1;
                }
            });
            $scope.boxModel.ODDQuestionChoices.splice($scope.boxModel.ODDQuestionLabels.length);
        };
    }
})();